import React from 'react';
import Footer from '../app-shell/Footer/Footer';

const footers = [{ path: '*', element: <Footer /> }];

export default footers;
